import Player from "@vimeo/player";

export default class VimeoVideoPlayer {

  constructor(options) {
    this.videoId = options.videoId;
    this.onClose = options.onClose;
    this.sizeList = [
      {width: 0, height: 0}, // mobile screens lower than any player => new window
      {width: 640, height: 360},
      {width: 853, height: 480},
      {width: 1280, height: 720}
    ];
  }


  openVideo() {
    let i = 0;

    for (i; i < this.sizeList.length; i++) {
      if (document.documentElement.clientHeight < this.sizeList[i].height ||
          document.documentElement.clientWidth < this.sizeList[i].width) break;
    }
    i--;

    this.currentWidth = this.sizeList[i].width;

    if (i === 0) {
      window.location.href = `https://vimeo.com/${this.videoId}`;
    } else {
      let modal = new Modal();
      modal.setContent(`<div id="player"></div>`);

      modal.elem.addEventListener('modal-remove', () => {
        if (this.player) {
          this.player.destroy();
          this.player = null;
        }
        if (this.onClose) this.onClose.call(this);
      });

      this.initPlayer();
    }
  }

  initPlayer() {
    if (this.player) {
      this.player.destroy();
    }

    this.player = new Player('player', {
      id: this.videoId,
      autoplay: true,
      width: this.currentWidth
    });
  }
}
